/**
 * product-detail custom element
 *
 * - swatch clicks render section's via Shopify section rendering API
 * - listen for addon selections and update product-form id/qty inputs for adding bundles/addons to cart
 * - @TODO: update document title on swatch change
 * - @TODO: fix selected swatch on history pops
*/

/* Currency formatter */
window.Shopify = window.Shopify || {};
window.Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /{{\s*(\w+)\s*}}/;
  var formatString = (format || window.theme?.moneyFormat || '${{amount}}');
  function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');
      if (isNaN(number) || number == null) {
          return 0;
      }
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents = parts[1] ? (decimal + parts[1]) : '';
      return dollars + cents;
  }
  switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
      case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
      case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
      case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
  }
  return formatString.replace(placeholderRegex, value);
};

(() => {
  class ProductDetail extends HTMLElement {
    constructor() {
      super();
      this.pdpEls();
      this.pdpSettings();
      this.pdpVerifiedFitInit();
      this.pdpListeners();
      this.productSticky();
    }

    swatchUnsubscriber = undefined;
    variantChangeUnsubscriber = undefined;

    pdpVerifiedFitInit() {
      this.handle = this.dataset.handle;
      this.id = this.dataset.id;
      this.pdpFitEls();
      this.storedProduct = window.productInStorage(this.handle);
      this.pdpIsVerifiedFit = typeof this.storedProduct !== 'undefined';
      this.dataset.isVerified = this.pdpIsVerifiedFit;
      this.pdpVerifiedInfo();
      if (this.hasStoredVehicle) this.pdpVerifiedVehicleName();
    }

    connectedCallback() {
      this.swatchUnsubscriber = window.subscribe(PUB_SUB_EVENTS.swatchChange, event => {
        if (event.source !== 'product-detail') return;
        this.swatchVariants = event.data.variants;
        this.onChange(event.url);
      });

      this.variantChangeUnsubscriber = window.subscribe(PUB_SUB_EVENTS.variantChange, event => {
        if (event.sectionId !== this.sectionId) return;
        this.currentVariant = event.currentVariant;
        this.onVariantChange();
      });
    }

    disconnectedCallback() {
      const unsubscribers = [
        this.swatchUnsubscriber,
        this.variantChangeUnsubscriber,
      ];

      unsubscribers.forEach(unsubscriber => unsubscriber && unsubscriber());
    }

    pdpEls() {
      this.addToCartEl = this.querySelector('[data-product-add-to-cart]');
      this.addonInputEls = this.querySelectorAll('[data-product-addon-inputs]');
      this.bundleInputEl = this.querySelector('[data-product-bundle-prop]');
      this.bundledWithInputEl = this.querySelector('[data-product-bundled-with]');
      this.sectionEl = this.closest('.shopify-section');
      this.sectionId = this.sectionEl.id.split('shopify-section-')[1];
      this.infoEl = this.querySelector(`#ProductInfo-${this.sectionId}`);
      this.mediaEl = this.querySelector('.pdp__media');
      this.pageSectionEls = this.closest('main').querySelectorAll('.shopify-section');
      this.vehicleMenu = document.querySelector('vehicle-menu');
      this.pdpFitEls();
    }

    pdpFitEls() {
      this.pdpFitmentNotesListEl = this.querySelector('[pdp-fitment-notes-list]');
      this.pdpPositionEl = this.querySelector('[data-pdp-vehicle-fit-val="position"]');
      this.pdpQuantityEl = this.querySelector('[data-pdp-vehicle-fit-val="quantity"]');
      this.pdpVerifiedFitEl = this.querySelector('[data-pdp-verified-fit]');
    }

    pdpVerifiedVehicleName() {
      this.vehicleDataEls = this.querySelectorAll('[data-pdp-vehicle-data-val]');
      this.vehicleDataEls.forEach(el => {
        const key = el.dataset.pdpVehicleDataVal;
        const value = this.vehicleMenu?.getVehicleDataValue(key);
        el.innerText = value ? value.replace(' Pickup', '') : '';
      });
    }

    pdpVerifiedInfo() {
      // Quantity
      if (this.pdpQuantityEl) this.pdpQuantityEl.innerText = this.storedProduct?.quantity ? this.storedProduct.quantity : '';

      // Position
      if (this.pdpPositionEl) this.pdpPositionEl.innerText = this.storedProduct?.position ? this.storedProduct.position : '';

      // Fitment Notes
      if (this.pdpFitmentNotesListEl) {
        let notesHTML = '';
        this.storedProduct?.fitmentNotes?.forEach(note => {
          notesHTML += !this.storedProduct?.fitmentNotes ? null : `
            <li>${note}</li>
          `
        });
        this.pdpFitmentNotesListEl.innerHTML = notesHTML;
      }

      if (!this.pdpVerifiedFitEl) return;
      this.pdpVerifiedFitEl.classList.add(this.pdpIsVerifiedFit ? 'is-verified-fit' : 'not-verified-fit');
      this.pdpVerifiedFitEl.classList.remove(this.pdpIsVerifiedFit ? 'not-verified-fit' : 'is-verified-fit');
      this.pdpVerifiedFitEl.classList.remove('pdp__verified-fit--loading');
    }

    isVerifiedFit() {
      return window.verifiedIds && verifiedIds.length > 0 && verifiedIds.includes(`gid://shopify/Product/${window.productId}`);
    }

    pdpSettings() {
      this.displayedFitmentNotes = null;
      this.handle = this.dataset.handle;
      this.id = this.dataset.id;
      this.hasStoredVehicle = window.storedVehicleData !== null;
      this.idsToUpdate = ['pdpBadge', 'pdpGallery', 'pdpTitle', 'price', 'variantRadios', 'productForm', 'pdpAddons', 'pdpSecondary'];
      this.sectionIds = [];
      this.pageSectionEls.forEach(section => this.sectionIds.push(section.id.split('shopify-section-')[1]));

      const installmentsEl = this.querySelector('#product-form-installment');
      if (!installmentsEl) return;
      this.productFormInstallment = {
        el: installmentsEl,
      }
      this.productFormInstallment.id = this.productFormInstallment.el.querySelector('[name="id"]');
      this.productFormInstallment.productId = this.productFormInstallment.el.querySelector('[name="product-id"]');
    }

    pdpListeners() {
      subscribe(PUB_SUB_EVENTS.vehicleData, e => {
        this.hasStoredVehicle = true;
        this.pdpVerifiedVehicleName();
        this.pdpVerifiedFitInit();
      });

      const onHistoryChange = () => {
        const updateActiveSwatch = true;
        this.updateContent(location.href, updateActiveSwatch);
      };

      window.addEventListener('popstate', onHistoryChange);
      window.addEventListener('submit', (e) => this.bis(e));
    }

    bis(e) {
      if (e.target.matches('[data-form-bis]')) {
        e.preventDefault();
        const email = document.querySelector('#bis_email').value;
        const id = document.querySelector('product-form input[name="id"]').value;

        const klaviyoPayload = {
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                  },
                },
              },
              channels: ['EMAIL'],
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: '$shopify:::$default:::' + id,
                },
              },
            },
          },
        };

        const endPoint = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + window.klaviyoCompanyID;
        const requestOptions = {
          method: 'POST',
          headers: {
            'content-type': 'application/vnd.api+json',
            revision: '2025-01-15',
          },
          body: JSON.stringify(klaviyoPayload),
          redirect: 'follow',
        };

        const backInStockForm = document.querySelector('.product__bis');

        fetch(endPoint, requestOptions).then((response) => {
          if (response.ok) {
            backInStockForm.classList.remove('error');
            backInStockForm.classList.add('success');
            backInStockForm.querySelector('[data-form-bis]').style.display = 'none';
            backInStockForm.querySelector('[data-bis-success]').classList.remove('hide');
          } else {
            backInStockForm.classList.add('error');
          }
        })
        .catch((error) => {
          backInStockForm.classList.add('error');
        });

      }
    }

    addonSelectedIndex(id, selectedData) {
      return selectedData.findIndex(item => item.id === id);
    }

    onChange(url) {
      this.updateContent(url);
    }

    onVariantChange() {
      this.updateBIS();
    }

    updateBIS() {
      const container = document.querySelector('[data-form-holder]');

      if (container) {
        if (this.currentVariant.available) {
          container.classList.remove('product-form-holder--bis');
        } else {
          container.classList.add('product-form-holder--bis');
        }
      }
    }

    updateActiveSwatch(url) {
      const activeSwatchEl = this.infoEl.querySelector(`.product-swatches__item--active`);
      if (activeSwatchEl) activeSwatchEl.classList.remove('product-swatches__item--active');
      const newActiveSwatchEl = this.infoEl.querySelector(`[data-swatch-item][href="${url}"]`);
      newActiveSwatchEl && newActiveSwatchEl.classList.add('product-swatches__item--active');
    }

    updateProductFormInstallment() {
      // this.productFormInstallment.id = newId;
      // this.productFormInstallment.productId = newProductId;
    }

    updateContent(url, updateActiveSwatch = false) {
      fetch(`${url}?section_id=${this.sectionId}`)
        .then(response => response.text())
        .then(responseText => {
          this.updateDetails(responseText);
          this.updateUrl(url);
          if (updateActiveSwatch) this.updateActiveSwatch(url);
          requestAnimationFrame(() => {
            if (!this.swatchVariants) return;
            const selectedEl = this.querySelector('variant-radios input:checked');
            const selectedV = this.swatchVariants.find(v => v.title === selectedEl.value);
            if (selectedV) {
              this.currentVariant = selectedV;
              const variantRadios = this.querySelector('variant-radios');
              if (variantRadios) {
                variantRadios.variantData = null;
                variantRadios.dispatchEvent(new Event('change'));
              }
            }
          });
        })
        .catch((e) => {
          console.error(e);
        });
    }

    updateDetails(html) {
      this.idsToUpdate.forEach(id => {
        const elId = `${id}-${this.sectionId}`;
        const el = this.querySelector(`#${elId}`);
        const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
        const parsedEl = parsedHtml.querySelector(`#${elId}`);
        if (!(el && parsedEl)) return;

        el.innerHTML = parsedEl.innerHTML;
      })

      requestAnimationFrame(() => {
        window.swipers();
        window.inView();
        window.pdpSwipers();
      });
    }

    updateAddToCartButton() {
      // this.addToCartPriceEl = this.querySelector('[data-product-add-to-cart-price]');
      // this.addToCartPriceEl.innerHTML = window.Shopify.formatMoney(this.price + this.addonData.addons.selectedTotal + this.addonData.bundles.selectedTotal).replace('.00', '');
    }

    updateForm(addonsData) {
      const bundleId = Date.now();

      Object.values(addonsData).forEach(item => {
        if (!item || !item.hasOwnProperty('id')) return;
        const el = this.querySelector(`[data-product-addon-inputs="${item.id}"]`);
        const quantityInput = el.querySelector('[data-addon-quantity-input]');
        const idInput = el.querySelector('[data-addon-id-input]');
        const bundleInput = el.querySelector('[data-addon-bundle-input]');
        const bundledWithInput = el.querySelector('[data-addon-bundled-with-input]');

        if (item.isSelected) {
          // if selected add name attribute
          idInput.setAttribute('name', idInput.dataset.name);
          quantityInput.setAttribute('name', quantityInput.dataset.name);

          // add _bundle_id prop to main product and bundled product
          if (bundleInput) {
            bundleInput.setAttribute('name', bundleInput.dataset.name);
            bundleInput.value = bundleId;
            bundledWithInput.setAttribute('name', bundledWithInput.dataset.name);
            this.bundleInputEl.setAttribute('name', this.bundleInputEl.dataset.name);
            this.bundleInputEl.value = bundleId;
            this.bundledWithInputEl.setAttribute('name', this.bundledWithInputEl.dataset.name);
          }

          quantityInput.value = item.quantity;
        } else {
          // if not selected remove name attribute
          idInput.removeAttribute('name');
          quantityInput.removeAttribute('name');
          if (bundleInput) {
            bundleInput.removeAttribute('name');
            bundleInput.removeAttribute('name');
            bundledWithInput.removeAttribute('name');
          }
        }
      });

      // remove _bundle_id_id prop from main product if no bundled products are selected
      const bundledItem = this.querySelector('[name][data-addon-bundle-input]');
      if (!bundledItem) {
        if (this.bundleInputEl) this.bundleInputEl.removeAttribute('name');
        if (this.bundledWithInputEl) this.bundledWithInputEl.removeAttribute('name');
      } else {
        if (this.bundledWithInputEl) this.bundledWithInputEl.value = bundledItem.dataset.title;
      }

      this.updateAddToCartButton(addonsData);
    }

    updateUrl(url) {
      url = this.currentVariant ? `${url}?variant=${this.currentVariant.id}` : url
      window.history.pushState({}, '', url)
    }

    updateVehicleData() {
      this.pdpVerifiedVehicleName();
    }

    // updateVehicleProducts(products) {
    //   this.vehicleProducts = products;
    //   this.pdpVerifiedInfo();
    // }

    productSticky() {
      const productSticky = document.querySelector('[data-product-sticky]');

      if (productSticky) {
        window.addEventListener('scroll', () => {
          const waypoint = document.querySelector('[data-product-sticky-waypoint]');
          const rect = waypoint.getBoundingClientRect();
          const topPosition = rect.top;

          if (topPosition < 0) {
            if (!window.searchMenuOpen) productSticky.classList.add('active');
          } else {
            productSticky.classList.remove('active');
          }
        }, { passive: true });

        document.documentElement.classList.add('sticky-product-atc');
      }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('product-detail')) {
      customElements.define('product-detail', ProductDetail);
    }
  })
})();
